import { memo } from 'react';

import TeamInterest from './components/TeamInterest';
import { TeamInterestOptionsProvider, TeamInterestStoreProvider } from './store';
import type { TeamInterestOptions } from './types';

const App = ({ options }: { options: TeamInterestOptions }) => (
  <TeamInterestOptionsProvider options={options}>
    <TeamInterestStoreProvider>
      <TeamInterest />
    </TeamInterestStoreProvider>
  </TeamInterestOptionsProvider>
);

export default memo(App);
